import moment from 'moment';

export function getNextRecurDate({ days, intervalUnit, intervalAmount, timeOfDay, startsAt, weekInMonth }, RRule) {
  const weekDaysOptions = [
    { weekDay: 'Monday', rruleOption: RRule.MO },
    { weekDay: 'Tuesday', rruleOption: RRule.TU },
    { weekDay: 'Wednesday', rruleOption: RRule.WE },
    { weekDay: 'Thursday', rruleOption: RRule.TH },
    { weekDay: 'Friday', rruleOption: RRule.FR },
    { weekDay: 'Saturday', rruleOption: RRule.SA },
    { weekDay: 'Sunday', rruleOption: RRule.SU },
  ];

  const getFreq = freq => {
    switch (freq) {
      case 'day':
        return RRule.DAILY;
      case 'month':
        return RRule.MONTHLY;
      case 'week':
      default:
        return RRule.WEEKLY;
    }
  };

  const getWeekDays = weekDays =>
    weekDays.split(' ').map(day => weekDaysOptions.find(({ weekDay }) => weekDay === day).rruleOption);

  const getWeekDaysForMonthlyRecurrence = (startsAt, weekInMonth) => {
    if (weekInMonth === null) return null;
    return getWeekDays(startsAt.format('dddd')).map(weekDay => weekDay.nth(weekInMonth === -1 ? -1 : weekInMonth + 1));
  };

  const [hour, minute] = timeOfDay.split(':');

  const optionsForRRule = {
    freq: getFreq(intervalUnit),
    dtstart: new Date(Date.UTC(startsAt.year(), startsAt.month(), startsAt.date(), Number(hour), Number(minute))),
    interval: intervalAmount || 1,
    byweekday:
      intervalUnit === 'day'
        ? null
        : intervalUnit === 'week'
        ? getWeekDays(days)
        : getWeekDaysForMonthlyRecurrence(startsAt, weekInMonth),
  };

  const rule = new RRule(optionsForRRule);

  const currentTime = moment();

  const nextRecurDate = rule.after(
    new Date(
      Date.UTC(currentTime.year(), currentTime.month(), currentTime.date(), currentTime.hour(), currentTime.minute())
    )
  );

  return moment(nextRecurDate).utc();
}
